import React from 'react'
import R from 'ramda'
import {connect} from 'react-redux'

class FitOnSearchChange extends React.Component{
  componentWillReceiveProps(nextProps){
    const prevEstateListIdsIndex = this.props.estateListIdsIndex
    const estateListIdsIndex = nextProps.estateListIdsIndex
    
    if(!R.equals(prevEstateListIdsIndex, estateListIdsIndex)){
      // TODO: il faudrait aussi considérer les coordonnées des POIs
      const coordinates = R.map((id) => nextProps.estates[id].data.coordinates, R.keys(estateListIdsIndex))
      if(coordinates.length>0){
          const boundsOfSearchResults = R.reduce((acc, coordinate) => acc.extend(coordinate), new L.LatLngBounds(), coordinates)
          this.props.map.fitBounds(boundsOfSearchResults, {animate: true })
      }
    }
  }
  render(){return null}
}
const mapStateToProps = state => ({
  estates: state.estates,
  estateListIdsIndex: state.estateListIdsIndex,
})
export default connect(mapStateToProps)(FitOnSearchChange)



/** WEBPACK FOOTER **
 ** ./app/components/FitOnSearchChange.jsx
 **/